import React, { useContext, useState } from "react";
const BreadcrumbContext = React.createContext();

export function useBreadcrumb() {
    return useContext(BreadcrumbContext);
}

export function BreadcrumbProvider({ children }) {
    const [extra] = useState([]);

    const value = {
        extra
    };

    return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
}

export default BreadcrumbContext;